import React from 'react'
import styled from '@emotion/styled'
import RewardCard from './RewardCard'
import CountryTags from './CountryTags'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const RewardContainer = styled.div`
  display: grid;
  grid-gap: 28px;
  grid-template-columns: auto auto auto auto;
  max-width: 708px;
`

const arr = (new Array(12)).fill(0)

const OverviewTab = ({ rewards }) => {

  return (
    <Container>
      <span>The following rewards are available to your members on their app. Learn how members earn points here.</span>
      <CountryTags />
      <RewardContainer>
        {rewards.map((reward) => <RewardCard reward={reward} />)}
      </RewardContainer>
    </Container>
  )
}

export default OverviewTab